import {
  ApplicationConfig,
  ErrorHandler,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';
import {
  BOT_SERVICE_TOKEN,
  COMPONENT_REGISTRY,
  surveyAuthInterceptor,
} from '@hyper-inferno/survey-elements-core-ui';
import * as Sentry from '@sentry/angular'; // Recommended to import as Sentry

import { provideAnimations } from '@angular/platform-browser/animations';
import {
  provideRouter,
  withComponentInputBinding,
  withRouterConfig,
} from '@angular/router';
import { appRoutes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { APP_CONTEXT, ENV, environment } from '@hyper-inferno/hyper-base-ng';
import { QuestionType } from '@hyper-inferno/survey-elements-core';
import { SurveyBotWeb } from '@hyper-inferno/survey-bot-web';

import * as projectJson from '../../package.json';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideAnimations(),
    provideRouter(
      appRoutes,
      withComponentInputBinding(),
      withRouterConfig({
        onSameUrlNavigation: 'reload',
        paramsInheritanceStrategy: 'always',
      }),
    ),
    provideHttpClient(
      withInterceptors([surveyAuthInterceptor]), // REGISTER HERE
    ),
    {
      provide: COMPONENT_REGISTRY,
      useValue: {
        'open-ended': () =>
          import('@hyper-inferno/open-ended-ui').then((m) => m.OpenEndedUi),
        'single-choice': () =>
          import('@hyper-inferno/single-choice-ui').then(
            (m) => m.SingleChoiceUi,
          ),
        'multiple-choice': () =>
          import('@hyper-inferno/multiple-choice-ui').then(
            (m) => m.MultipleChoiceUi,
          ),
        numeric: () =>
          import('@hyper-inferno/numeric-ui').then((m) => m.NumericUi),
        video: () => import('@hyper-inferno/video-ui').then((m) => m.VideoUi),
        voice: () => import('@hyper-inferno/voice-ui').then((m) => m.VoiceUi),
        'click-to-rank': () =>
          import('@hyper-inferno/click-to-rank-ui').then(
            (m) => m.ClickToRankUi,
          ),
        'drop-down-single-choice': () =>
          import('@hyper-inferno/drop-down-single-choice-ui').then(
            (m) => m.DropDownSingleChoiceUi,
          ),
        'drop-down-multiple-choice': () =>
          import('@hyper-inferno/drop-down-multiple-choice-ui').then(
            (m) => m.DropDownMultipleChoiceUi,
          ),
        image: () => import('@hyper-inferno/image-ui').then((m) => m.ImageUi),
        [QuestionType.SINGLE_GRID]: () =>
          import('@hyper-inferno/grid-single-choice-ui').then(
            (m) => m.GridSingleChoiceUi,
          ),
        [QuestionType.MULTIPLE_GRID]: () =>
          import('@hyper-inferno/grid-multiple-choice-ui').then(
            (m) => m.GridMultipleChoiceUi,
          ),
        [QuestionType.DISPLAY]: () =>
          import('@hyper-inferno/display-ui').then((m) => m.DisplayUi),
        [QuestionType.LOCATION]: () =>
          import('@hyper-inferno/location-ui').then((m) => m.LocationUi),
        [QuestionType.MIXED_GRID]: () =>
          import('@hyper-inferno/grid-mixed-ui').then((m) => m.GridMixedUi),
      },
    },
    { provide: BOT_SERVICE_TOKEN, useClass: SurveyBotWeb },
    {
      provide: ENV,
      useValue: environment,
    },
    {
      provide: APP_CONTEXT,
      useValue: {
        appName: 'respondent-web',
        appVersion: projectJson.version,
      },
    },
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({}),
    },
  ],
};
